import { billerAccountsRetrievers } from 'app-components/flux/biller-accounts';
import { billerLoginsActions } from 'app-components/flux/biller-logins';
import { scheduledTransactionsActions, scheduledTransactionsTypes } from 'app-components/flux/scheduled-transactions';
import { tracker } from 'app-components/utils/core';

export function HandleDisconnectOption(dispatch, model, billerLogin, location, removeUndo) {
  // if only one account associated with login, delete login
  const loginId = billerLogin?.id || '0';
  const connectedAccounts = billerAccountsRetrievers.getConnectedAccounts(loginId);
  if (loginId && connectedAccounts.size < 2 && billerLogin) {
    dispatch(billerLoginsActions.deleteBillerLogin(billerLogin));
  }
  dispatch(
    scheduledTransactionsActions.updateScheduledTransaction(
      scheduledTransactionsTypes.mkScheduledTransaction({ id: model?.id, billPresentmentAccountId: '' }),
      !removeUndo && { undo: { userMessage: 'Series Unlinked' } },
    ),
  );
  tracker.track(tracker.events.disconnectBiller, {
    initiator: location,
    biller_id: billerLogin?.providerBillerID,
    biller_name: billerLogin?.name,
  });
}

export function HandleEndOption(dispatch, model, billerLogin, location, removeUndo) {
  let track = false;
  if (model?.billPresentmentAccountId) {
    track = true;
    // if only one account associated with login, delete login
    const loginId = billerLogin?.id || '0';
    const connectedAccounts = billerAccountsRetrievers.getConnectedAccounts(loginId);
    if (loginId && connectedAccounts.size < 2 && billerLogin) {
      dispatch(billerLoginsActions.deleteBillerLogin(billerLogin));
    }
  }
  dispatch(
    scheduledTransactionsActions.updateScheduledTransaction(
      scheduledTransactionsTypes.mkScheduledTransaction({
        id: model.id,
        isCompleted: true,
        billPresentmentAccountId: '',
      }),
      !removeUndo && { undo: { userMessage: 'Series ended' } },
    ),
  );
  if (track && !removeUndo)
    tracker.track(tracker.events.disconnectBiller, {
      initiator: location,
      biller_id: billerLogin?.providerBillerID,
      biller_name: billerLogin?.name,
    });
}
